export const myTrips = `
  .rebooking-card {
    display: flex;
    align-items: center;

    &--icon {
      background: #f4f5f7;
      padding: 12px;
      border-radius: 50%;
      margin-right: 24px;

      i {
        color: #1abc9c;
        font-size: 36px;
      }
    }

    &--heading {
      h3 {
        font-size: 16px;
        font-weight: bold;
        color: #223254;
        margin-top: 0;
      }

      a {
        font-weight: 600;
        text-decoration: none;
        color: #1abc9c;
      }
    }
  }

  .main-title {
    font-weight: bold;
    font-size: 20px;
    color: #223254;
    margin: 24px 0;
  }
`;